import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['desktopRequiredStateShown', 'chromeRequiredStateShown'] as const;

export const recordingPlatformLockEvents = getMappedEvents([...EVENTS]);
